<div
  class="p-3 otro-medio-de-pago"
  [class.error-en-medio-de-pago]="formularioMedioDePago.invalid && submitted"
>
  <h2 class="mb-3 otro-medio-de-pago__title otro-medio-de-pago__title_error">
    Tus opciones para realizar el pago:
  </h2>
  <div class="row mb-4 flex-column">
    <div
      class="col-12 py-2"
      *ngIf="configuracionDePago.mediosPagoHabilitados.exito"
    >
      <div class="d-flex align-items-center">
        <h3
          class="pl-4 py-3 m-0 d-flex align-items-center otro-medio-de-pago__title otro-medio-de-pago__title_bold"
        >
          Tarjeta Éxito
        </h3>
        <img src="./assets/images/exito.png" alt="medio-pago-tarjeta-exito" />
      </div>
      <p class="pl-4 mb-0 otro-medio-de-pago__info">
        Recuerda que esta tarjeta es diferente a <b>MasterCard Éxito</b>. Si
        deseas pagar con la <b>MasterCard Éxito</b>, selecciona la opción
        <b>Tarjeta de crédito</b>.
      </p>
    </div>
    <div
      class="col-12 d-block d-md-flex align-items-center justify-content-start my-2"
      *ngIf="
        configuracionDePago.mediosPagoHabilitados.pse ||
        configuracionDePago.mediosPagoHabilitados.tarjetaCredito
      "
    >
      <app-input-check>
        <ng-container slot="descriptionRef">
          <h3 class="otro-medio-de-pago__title otro-medio-de-pago__title_bold">
            {{ MedioDePagoTexto() }}
          </h3>
        </ng-container>
        <ng-container slot="inputRef">
          <input
            type="radio"
            id="detalle-salud-otras-si"
            class="input-check mx-3"
            [formControl]="formularioMedioDePago"
            [value]="MEDIO_PAGO_PLACE_TO_PAY"
          />
        </ng-container>
      </app-input-check>
      <div class="otro-medio-de-pago__logos ml-3">
        <img
          *ngIf="!esProductoSoat"
          class="ml-2 otro-medio-de-pago__logos_general"
          src="./assets/images/logo-visa.svg"
          alt="medio-pago-visa"
        />
        <img
          *ngIf="!esProductoSoat"
          class="ml-2 otro-medio-de-pago__logos_general"
          src="./assets/images/logo-mastercard.svg"
          alt="medio-pago-mastercard"
        />
        <img
          *ngIf="!esProductoSoat"
          class="ml-2 otro-medio-de-pago__logos_general"
          src="./assets/images/logo-amex.svg"
          alt="medio-pago-amex"
        />
        <img
          *ngIf="!esProductoSoat"
          class="ml-2 otro-medio-de-pago__logos_general"
          src="./assets/images/logo-dinners.svg"
          alt="medio-pago-dinners"
        />
        <img
          *ngIf="configuracionDePago.mediosPagoHabilitados.pse"
          class="otro-medio-de-pago__logos_pse"
          src="./assets/images/logo-pse.svg"
          alt="medio-pago-pse"
        />
      </div>
    </div>
    <div
      class="col-12 d-block d-md-flex align-items-center justify-content-start my-2"
      *ngIf="configuracionDePago.mediosPagoHabilitados.botonBancolombia"
    >
      <app-input-check>
        <ng-container slot="descriptionRef">
          <h3 class="otro-medio-de-pago__title otro-medio-de-pago__title_bold">
            Cuenta de ahorros y Corriente
          </h3>
        </ng-container>
        <ng-container slot="inputRef">
          <input
            type="radio"
            id="detalle-salud-otras-si"
            class="input-check mx-3"
            [formControl]="formularioMedioDePago"
            [value]="MEDIO_PAGO_BANCOLOMBIA"
          />
        </ng-container>
      </app-input-check>
      <img
        src="./assets/images/medio-pago-bancolombia.svg"
        alt="medio-pago-bancolombia"
        class="otro-medio-de-pago__bancolombia ml-3"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-8">
      <div class="pl-4">
        <app-resumen-descuentos></app-resumen-descuentos>
      </div>
    </div>
  </div>
  <div class="row align-items-center">
    <div class="col-md-6 text-center align-middle">
      <h2 class="otro-medio-de-pago__total-price m-0" id="id-tarifa">
        TOTAL A PAGAR:
        {{ resumenDescuentos.total | currency: 'COP':'symbol-narrow':'0.0-0' }}
      </h2>
    </div>
    <div class="col-md-6 text-center">
      <button
        class="otro-medio-de-pago__button py-2 mt-2 mt-lg-0"
        (click)="onPagarOtroMedio()"
      >
        PAGAR
      </button>
    </div>
  </div>
</div>
